import React, { useEffect, useState } from 'react';
import { getConfiguration, saveConfiguration, clearCacheData } from '../../actions/configurationActions';
import { getForms } from '../../actions/formActions';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch, } from 'react-redux';
import SearchBox from '../Common/SearchBox/SearchBox';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { configToStrategy, strategyToConfig } from '../../utils/utility';
import { FaWindowClose } from 'react-icons/fa'; // Importing the plus icon
import _ from 'lodash'

const ManageConfiguration = (props) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const configLocationPath = location.pathname.split('/').filter(Boolean)[0];
    const general_form = configLocationPath == "configurations" ? "configuration_general_form" : "master_configuration_general_form";
    const configuration_form = "configuration_data_form";
    const isEdit = location.pathname.includes('/edit');
    const isAdd = location.pathname.includes('/add');
    const isCopy = location.pathname.includes('/copy');
    const formState = useSelector((state) => state.forms);
    const configurationState = useSelector((state) => state.configuration);
    const { configuration = {}, saveConfigurationRespnose = {} } = configurationState;
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[general_form] || {};
    const dataSearchBoxJson = formJson[configuration_form] || {};
    const [generalForm, setGeneralForm] = useState({});
    const [fetchingSearchForm, setFetchingSearchForm] = useState(_.isEmpty(searchBoxJson));
    const [fetchingDataForm, setFetchingDataForm] = useState(_.isEmpty(dataSearchBoxJson));
    const [updatedSearchBoxValues, setUpdatedSearchBoxValues] = useState({});
    const [updatedDataBoxValues, setUpdatedDataBoxValues] = useState({});
    const [buttonsDisabled, setButtonsDisabled] = useState(false);

    useEffect(() => {
        if (isEdit || isCopy) {
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id'); // Get the value of 'r'
            if (id != null) {
                dispatch(getConfiguration({ id }, configLocationPath));
                dispatch(getForms(general_form));
            }
            else {
                toast.error('In-valid ID');
            }
        } else {
            dispatch(getForms(general_form));
        }

        return () => {
            dispatch(clearCacheData());
        }
    }, []);

    useEffect(() => {
        if (!_.isEmpty(saveConfigurationRespnose)) {
            toast.success('Successfully Saved');
            navigate(`/${configLocationPath}`);
        }
    }, [saveConfigurationRespnose])

    useEffect(() => {
        if (!_.isEmpty(searchBoxJson) && (isCopy || isAdd || (isEdit && !_.isEmpty(configuration)))) {
            let _searchBoxJson = searchBoxJson;
            if (isEdit)
                _searchBoxJson = disableField(searchBoxJson, 'type');
            setGeneralForm(_searchBoxJson);
            setUpdatedSearchBoxValues(getCommonPayload(configuration));
            setUpdatedDataBoxValues(getDataPayload(configuration));
            setFetchingSearchForm(false);
        }
    }, [searchBoxJson, configuration])

    useEffect(() => {
        if (!_.isEmpty(dataSearchBoxJson)) {
            const _searchBoxJson = disableField(generalForm, 'type');
            setGeneralForm(_searchBoxJson);
            const { data = {} } = configuration;
            // setUpdatedDataBoxValues(data);
            setFetchingDataForm(false);
            setFetchingSearchForm(false);
        }
    }, [dataSearchBoxJson])

    const disableField = (_formJson, fieldId) => {
        if (_.isEmpty(_formJson))
            return _formJson;
        const { data = {} } = _formJson;
        const { section = [] } = data;
        const _section = section.map(_section => {
            const { fields = [] } = _section;
            const _fields = fields.map(_field => {
                if (_field.id === fieldId || fieldId === '')
                    return { ..._field, disabled: true };
                return _field;
            })
            return { ..._section, fields: _fields };
        })
        return { ..._formJson, data: { ...data, section: _section } }
    }

    const normalizeInclusionExclusionItems = (items = []) => {
        if (!Array.isArray(items)) return [];
        return items
            .map((item) => {
                if (_.isString(item) || _.isNumber(item)) {
                    const key = String(item);
                    return { key, name: key };
                }
                const key = _.get(item, 'key', _.get(item, 'value', _.get(item, 'id', _.get(item, 'configurationId', ''))));
                if (!key) return null;
                const name = _.get(item, 'name', _.get(item, 'label', String(key)));
                return { ...item, key: String(key), name };
            })
            .filter(Boolean);
    }

    const mapItemsToIds = (items = []) => {
        if (!Array.isArray(items)) return [];
        return items
            .map((item) => {
                if (_.isString(item) || _.isNumber(item)) return String(item);
                return _.get(item, 'key', _.get(item, 'value', _.get(item, 'id', _.get(item, 'configurationId', ''))));
            })
            .filter((value) => value !== undefined && value !== null && String(value).length > 0)
            .map(String);
    }

    /*
    Function to accept the configuration json from backend and form the Search Box JSON
    */
    const getDataPayload = (configuration) => {
        const { type = '', data = {} } = configuration;

        if (type === "GENERAL_CONFIG" || type == 'ZERODHA' || type === "COMPANY_CONFIG") {
            return data;
        }

        if (type === 'STRATEGY_ANALYSIS') {
            return configToStrategy({ data });
        }

        if (type === 'TRADE_CALCULATION') {
            const { charges = [], ...restData } = data;
            return { charges, general: restData };
        }

        if (type == 'CRON_JOB') {
            const { api = [], ...restData } = data;
            const _api = api.map(apiData => {
                const { options = {}, ..._restData } = apiData;
                const { content = {} } = options;
                return { ..._restData, ...options, content: JSON.stringify(content) };
            });
            return { api: _api, general: restData }
        }

        if (type === 'LIVE_TRACKING') {
            const inclusionIds = _.get(data, 'includedConfigurationIds', []);
            return {
                ...data,
                inclusion: {
                    inclusion: normalizeInclusionExclusionItems(inclusionIds),
                    exclusion: [],
                }
            };
        }

        return {};
    }

    /*
    Function to accept the Search Box JSON and form the configuration json to backend
    */
    const formDataPayload = (payload) => {
        const { type = '' } = updatedSearchBoxValues;
        try {
            if (type === 'GENERAL_CONFIG' || type == 'ZERODHA' || type === "COMPANY_CONFIG") {
                return { data: payload, criteria: {} };
            }
            if (type === 'STRATEGY_ANALYSIS') {
                return { data: strategyToConfig(payload), criteria: {} };
            }
            if (type === 'TRADE_CALCULATION') {
                const { charges, general } = payload;
                return { data: { charges, ...general }, criteria: {} };
            }
            if (type === 'CRON_JOB') {
                const { api = [], general = {} } = payload;
                const _api = api.map(data => {
                    const { type = '', api = '', content = '', urlAppend = '' } = data;
                    if (type == 'genericConnect') {
                        return {
                            type, options: { api, content: JSON.parse(content), urlAppend }
                        }
                    } else {
                        return {
                            type, options: {}
                        }
                    }
                })
                return { data: { api: _api, ...general }, criteria: {} };
            }
            if (type === 'LIVE_TRACKING') {
                const {
                    inclusion: inclusionField = {},
                    ...restData
                } = payload || {};
                const inclusionItems = _.get(inclusionField, 'inclusion',
                    _.get(inclusionField, 'inclusions',
                        _.get(restData, 'includedConfigurationIds', [])
                    )
                );
                const inclusionIds = mapItemsToIds(inclusionItems);
                return {
                    data: { ...restData, includedConfigurationIds: inclusionIds },
                    criteria: { inclusion: {}, exclusion: {} }
                };
            }
            return { data: payload, criteria: {} }
        } catch (ex) {
            toast.error(ex.message);
            console.log(ex);
            throw ex;
        }
    }

    const getCommonPayload = configuration => {
        const { configurationId = '', deleted = false, description = '', enabled = true, priority = 0, type = '' } = configuration;
        return { configurationId: isCopy ? '' : configurationId, deleted, description, enabled, priority, type };
    }

    const handleSearch = (payload) => {
        const { type = '' } = payload;
        setUpdatedSearchBoxValues(payload);
        setFetchingSearchForm(true);
        setFetchingDataForm(true);
        setButtonsDisabled(true);
        let _searchBoxJson = disableField(generalForm, '');
        setGeneralForm(_searchBoxJson);
        dispatch(getForms('configuration_' + type, '', configuration_form, ''))
    }

    const handleSubmit = (payload) => {
        try {
            const { data = {}, criteria = {} } = formDataPayload(payload);
            const finalPayload = { ...updatedSearchBoxValues, data, criteria };
            dispatch(saveConfiguration(finalPayload, configLocationPath));
        } catch (ex) {

        }
    }

    // console.log("updatedSearchBoxValues", updatedSearchBoxValues);
    // console.log("updatedDataBoxValues", updatedDataBoxValues);

    return (
        <div style={{ position: 'relative', paddingBottom: '80px' }}> {/* Added padding-bottom */}
            <SearchBox
                searchBoxJson={generalForm}
                onSearch={handleSearch}
                fetchingForm={fetchingSearchForm}
                updatedValues={updatedSearchBoxValues}
                buttonsDisabled={buttonsDisabled}
            />
            {!_.isEmpty(dataSearchBoxJson) && buttonsDisabled ?
                <SearchBox
                    searchBoxJson={dataSearchBoxJson}
                    onSearch={handleSubmit}
                    fetchingForm={fetchingDataForm}
                    updatedValues={updatedDataBoxValues}
                    buttonsDisabled={false}
                />
                : ''}
            <div
                onClick={() => { navigate('/configurations') /*window.close()*/ }}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'red',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={'Cancel'}
            >
                <FaWindowClose size={20} />
            </div>
        </div>
    );
}

export default ManageConfiguration;
